var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.imageSrc)?_c('image-preview',{staticClass:"payee-info-preview",attrs:{"src":_vm.props.imageSrc,"size":"100%","remove":""},on:{"remove":function () { return _vm.listeners['remove'] && _vm.listeners['remove'](); }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }